import React, { useState, useEffect } from 'react';
import { Redirect } from "react-router-dom";
import { messageTypeEnum } from '../../enum';
import { connect } from 'react-redux';
import ListadoDocumentosConfirmacion from './ListadoDocumentosConfirmacion';
import { documentoElectronico } from '../../models/documentoElectronico';
import { clearErrors, postConfirmacionFacturas, getConfirmados, clearConfirmados } from '../../actions';
import BasicMessage from '../messages/basicMessage';
import { Button, Modal } from 'semantic-ui-react'
import { ValidarEmisor, ValidarLogin, IsNotNullOrEmptyOrUndefined } from '../../util';
import convert from 'xml-js';
import { estadoConfirmacionEnum } from '../../enum/index.js';
import RenderHeader from '../shared/RenderHeader';
import { use } from 'react';

let tempFiles = [];
const ConfirmarFacturas = (props) => {
  const { token } = ValidarLogin(props);
  const { emisor } = ValidarEmisor(props);
  const { confirmacionFacturasState } = props;
  const [documentos, setDocumentos] = useState([]);
  const [archivos, setArchivos] = useState([]);
  const [elementos, setElementos] = useState([]);
  const [mgType, setMgType] = useState('');
  const [message, setMessage] = useState('');
  const [isActiveModalError, setIsActiveModalError] = useState(false);

  useEffect(() => {
    props.clearErrors();
  }, []);

  useEffect(() => {
    if (confirmacionFacturasState) {
      resultadoConfirmacion(confirmacionFacturasState);
    }
  }, [confirmacionFacturasState]);

  useEffect(() => {
    if (message !== '') {
      setIsActiveModalError(true);
    }
  }, [message]);
  
  if (token === null) {
    return <Redirect to='/login' />;
  }

  const resultadoConfirmacion = (resp) => {
    let array = Object.keys(resp.respuesta);
    let arrayDocumentos = documentos;
    array.map((dato) => {
      let buscar = resp.respuesta[dato]
      arrayDocumentos.map((item) => {
        if (item.Clave == buscar.ClaveDocumento) {
          item.Estado = buscar.EstadoConformacion;
        }
      });
    })
    setDocumentos(arrayDocumentos);
  };

  const subirArchivos = (e) => {
    closeMessages();
    setElementos([]);
    setDocumentos([]);
    convertirXMLJson(e);
  };

  const getNum = (val) => {
    if (isNaN(val)) {
      return 0;
    }
    return val;
  }

  const convertirXMLJson = (e) => {
    e.preventDefault();
    tempFiles = [];
    for (let i = 0; i < e.target.files.length; i++) {
      const reader = new FileReader()
      reader.readAsText(e.target.files[i]);
      reader.onload = () => {
        const fileXml = convert.xml2json(reader.result, { compact: true, spaces: 4 });
        tempFiles.push(JSON.parse(fileXml));
        setArchivos([
          ...tempFiles
        ]);
      };
    }

  }

  const crearDocumentos = (value) => {
    const factura = {
      Clave: '',
      CodigoActividad: '',
      NumeroConsecutivo: '',
      FechaEmision: "",
      Emisor: {
        Id: 0,
        Nombre: '',
        Identificacion: {
          Tipo: '',
          Numero: ''
        },
        NombreComercial: '',
        Ubicacion: {
          Provincia: '',
          Canton: '',
          Distrito: '',
          Barrio: '',
          OtrasSenas: ''
        },
        Telefono: {
          CodigoPais: '',
          NumTelefono: ''
        },
        CorreoElectronico: '',
        AplicacionId: 0
      },
      Receptor: {
        EmisorId: 0,
        IdentificacionExtranjero: '',
        OtrasSenasExtranjero: '',
        Id: 0,
        Nombre: '',
        Identificacion: {
          Tipo: '01',
          Numero: ''
        },
        NombreComercial: null,
        Ubicacion: null,
        Telefono: null,
        CorreoElectronico: null,
      },
      CondicionVenta: '01',
      PlazoCredito: '0',
      MedioPago: '01',
      DetalleServicio: {
        LineaDetalle: []
      },
      OtrosCargosPorDocumento: null,
      ResumenFactura: {
        CodigoTipoMoneda: {
          CodigoMoneda: 'CRC',
          TipoCambio: 1
        },
        TotalServGravados: 0,
        TotalServExentos: 0,
        TotalServExonerado: 0,
        TotalMercanciasGravadas: 0,
        TotalMercanciasExentas: 0,
        TotalMercExonerada: 0,
        TotalGravado: 0,
        TotalExento: 0,
        TotalExonerado: 0,
        TotalVenta: 0,
        TotalDescuentos: 0,
        TotalVentaNeta: 0,
        TotalImpuesto: 0,
        TotalIvaDevuelto: 0,
        TotalOtrosCargos: 0,
        TotalComprobante: 0
      },
      InformacionReferencia: null,
      Normativa: {
        NumeroResolucion: '',
        FechaResolucion: ''
      },
      DocumentoFirmado: '',
      SituacionDocumento: '',
      Otros: null
    };

    factura.Clave = value?.FacturaElectronica?.Clave?._text;
    factura.CodigoActividad = value?.FacturaElectronica?.CodigoActividad?._text;
    factura.CondicionVenta = value?.FacturaElectronica?.CondicionVenta?._text;
    factura.Estado = value?.FacturaElectronica?.Estado;
    let telefonoEmisor = {
      CodigoPais: value?.FacturaElectronica?.Emisor?.Telefono?.CodigoPais?._text,
      NumTelefono: value?.FacturaElectronica?.Emisor?.Telefono?.NumTelefono?._text
    };
    let ubicacionEmisor = {
      Provincia: value?.FacturaElectronica?.Emisor?.Ubicacion?.Provincia?._text,
      Canton: value?.FacturaElectronica?.Emisor?.Ubicacion?.Canton?._text,
      Distrito: value?.FacturaElectronica?.Emisor?.Ubicacion?.Distrito?._text,
      Barrio: value?.FacturaElectronica?.Emisor?.Ubicacion?.Barrio?._text,
      OtrasSenas: valorVacio(value?.FacturaElectronica?.Emisor?.Ubicacion?.OtrasSenas?._text)
    };
    let identificacionEmisor = {
      Tipo: value?.FacturaElectronica?.Emisor?.Identificacion?.Tipo?._text,
      Numero: value?.FacturaElectronica?.Emisor?.Identificacion?.Numero?._text
    }
    let Emisor = {
      Nombre: value?.FacturaElectronica?.Emisor?.Nombre?._text,
      NombreComercial: value?.FacturaElectronica?.Emisor?.NombreComercial?._text,
      CorreoElectronico: value?.FacturaElectronica?.Emisor?.CorreoElectronico?._text,
      Telefono: telefonoEmisor,
      Ubicacion: ubicacionEmisor,
      Identificacion: identificacionEmisor
    };
    factura.Emisor = Emisor;
    let identificacionReceptor = {
      Numero: valorVacio(value?.FacturaElectronica?.Receptor?.Identificacion?.Numero?._text),
      Tipo: valorVacio(value?.FacturaElectronica?.Receptor?.Identificacion?.Tipo?._text)
    };
    let telefonoReceptor = {
      CodigoPais: valorVacio(value?.FacturaElectronica?.Receptor?.Telefono?.CodigoPais?._text),
      NumTelefono: valorVacio(value?.FacturaElectronica?.Receptor?.Telefono?.NumTelefono?._text)
    };
    let ubicacionReceptor = {
      Provincia: valorVacio(value?.FacturaElectronica?.Receptor?.Ubicacion?.Provincia?._text),
      Canton: valorVacio(value?.FacturaElectronica?.Receptor?.Ubicacion?.Canton?._text),
      Barrio: valorVacio(value?.FacturaElectronica?.Receptor?.Ubicacion?.Distrito?._text),
      OtrasSenas: valorVacio(value?.FacturaElectronica?.Receptor?.Ubicacion?.OtrasSenas?._text)
    };
    let Receptor = {
      Nombre: valorVacio(value?.FacturaElectronica?.Receptor?.Nombre?._text),
      CorreoElectronico: valorVacio(value?.FacturaElectronica?.Receptor?.CorreoElectronico?._text),
      CorreoElectronico: valorVacio(value?.FacturaElectronica?.Receptor?.CorreoElectronico?._text),
      IdentificacionExtranjero: valorVacio(value?.FacturaElectronica?.Receptor?.IdentificacionExtranjero?._text),
      OtrasSenasExtranjero: valorVacio(value?.FacturaElectronica?.Receptor?.OtrasSenasExtranjero?._text),
      Identificacion: identificacionReceptor,
      Ubicacion: ubicacionReceptor,
      Telefono: telefonoReceptor
    };
    factura.Receptor = Receptor;
    const lineaDetalle = [];
    let totalItems = 1;
    if (value?.FacturaElectronica?.DetalleServicio?.LineaDetalle?.length > 0) {
      totalItems = value?.FacturaElectronica?.DetalleServicio?.LineaDetalle.length;
    }
    for (let index = 0; index < totalItems; index++) {
      let item = value?.FacturaElectronica?.DetalleServicio?.LineaDetalle;
      if (totalItems !== 1) {
        item = value?.FacturaElectronica?.DetalleServicio?.LineaDetalle[index];
      }
      let codigoComercial = {
        Codigo: item?.CodigoComercial?.Codigo?._text,
        Tipo: item?.CodigoComercial?.Tipo?._text
      };
      let descuento = {
        MontoDescuento: parseFloat(getNum(item?.Descuento?.MontoDescuento?._text)).toFixed(3),
        NaturalezaDescuento: item?.Descuento?.NaturalezaDescuento?._text
      };
      let Exoneracion = {
        FechaEmision: item?.Impuesto?.Exoneracion?.FechaEmision?._text,
        MontoExoneracion: parseFloat(getNum(item?.Impuesto?.Exoneracion?.MontoExoneracion?._text)).toFixed(3),
        NombreInstitucion: item?.Impuesto?.Exoneracion?.NombreInstitucion?._text,
        NumeroDocumento: item?.Impuesto?.Exoneracion?.NumeroDocumento?._text,
        TarifaExonerada: parseInt(item?.Impuesto?.Exoneracion?.TarifaExonerada?._text),
        TipoDocumento: item?.Impuesto?.Exoneracion?.TipoDocumentoEX1?._text
      };
        let impuesto = {
        Codigo: item?.Impuesto?.Codigo?._text,
        CodigoTarifa: item?.Impuesto?.CodigoTarifaIVA?._text,
        FactorIVA: parseFloat(item?.Impuesto?.FactorCalculoIVA?._text).toFixed(3),
        Monto: parseFloat(getNum(item?.Impuesto?.Monto?._text)).toFixed(3),
        Tarifa: parseInt(item?.Impuesto?.Tarifa?._text),
        Exoneracion: Exoneracion
      };
      let linea = {
        BaseImponible: parseFloat(item?.BaseImponible?._text).toFixed(3),
        Cantidad: parseInt(item?.Cantidad?._text),
        Codigo: item?.Codigo?._text,
        CodigoComercial: codigoComercial,
        Descuento: descuento,
        Detalle: item?.Detalle?._text,
        Impuesto: impuesto,
        ImpuestoNeto: parseFloat(item?.ImpuestoNeto?._text).toFixed(3),
        MontoTotal: item?.MontoTotal?._text,
        MontoTotalLinea: item?.MontoTotalLinea?._text,
        NumeroLinea: parseInt(item?.NumeroLinea?._text),
        PrecioUnitario: parseFloat(item?.PrecioUnitario?._text).toFixed(3),
        SubTotal: parseFloat(item?.SubTotal?._text).toFixed(3),
        UnidadMedida: item?.UnidadMedida?._text
      };
      lineaDetalle.push(linea);
    }
    factura.DetalleServicio.LineaDetalle = lineaDetalle;
    factura.FechaEmision = value?.FacturaElectronica?.FechaEmision?._text;
    factura.NumeroConsecutivo = value?.FacturaElectronica?.NumeroConsecutivo?._text;
    factura.PlazoCredito = value?.FacturaElectronica?.PlazoCredito?._text;
    factura.MedioPago = value?.FacturaElectronica?.MedioPago?._text;

    let resumenFactura = {
      CodigoTipoMoneda: {
        CodigoMoneda: value?.FacturaElectronica?.ResumenFactura?.CodigoTipoMoneda?.CodigoMoneda?._text,
        TipoCambio: parseFloat(getNum(value?.FacturaElectronica?.ResumenFactura?.CodigoTipoMoneda?.TipoCambio?._text)).toFixed(3)
      },
      TotalServGravados: parseFloat(getNum(value?.FacturaElectronica?.ResumenFactura?.TotalServGravados?._text)).toFixed(3),
      TotalServExentos: parseFloat(getNum(value?.FacturaElectronica?.ResumenFactura?.TotalServExentos?._text)).toFixed(3),
      TotalServExonerado: parseFloat(getNum(value?.FacturaElectronica?.ResumenFactura?.TotalServExonerado?._text)).toFixed(3),
      TotalMercanciasGravadas: parseFloat(getNum(value?.FacturaElectronica?.ResumenFactura?.TotalMercanciasGravadas?._text)).toFixed(3),
      TotalMercanciasExentas: parseFloat(getNum(value?.FacturaElectronica?.ResumenFactura?.TotalMercanciasExentas?._text)).toFixed(3),
      TotalMercExonerada: parseFloat(getNum(value?.FacturaElectronica?.ResumenFactura?.TotalMercExonerada?._text)).toFixed(3),
      TotalGravado: parseFloat(getNum(value?.FacturaElectronica?.ResumenFactura?.TotalGravado?._text)).toFixed(3),
      TotalExento: parseFloat(getNum(value?.FacturaElectronica?.ResumenFactura?.TotalExento?._text)).toFixed(3),
      TotalExonerado: parseFloat(getNum(value?.FacturaElectronica?.ResumenFactura?.TotalExonerado?._text)).toFixed(3),
      TotalVenta: parseFloat(getNum(value?.FacturaElectronica?.ResumenFactura?.TotalVenta?._text)).toFixed(3),
      TotalDescuentos: parseFloat(getNum(value?.FacturaElectronica?.ResumenFactura?.TotalDescuentos?._text)).toFixed(3),
      TotalVentaNeta: parseFloat(getNum(value?.FacturaElectronica?.ResumenFactura?.TotalVentaNeta?._text)).toFixed(3),
      TotalImpuesto: parseFloat(getNum(value?.FacturaElectronica?.ResumenFactura?.TotalImpuesto?._text)).toFixed(3),
      TotalIvaDevuelto: parseFloat(getNum(value?.FacturaElectronica?.ResumenFactura?.TotalIvaDevuelto?._text)).toFixed(3),
      TotalOtrosCargos: parseFloat(getNum(value?.FacturaElectronica?.ResumenFactura?.TotalOtrosCargos?._text)).toFixed(3),
      TotalComprobante: parseFloat(getNum(value?.FacturaElectronica?.ResumenFactura?.TotalComprobante?._text)).toFixed(3)
    };
    factura.ResumenFactura = resumenFactura;
    factura.SituacionDocumento = value?.FacturaElectronica?.SituacionDocumento?._text;
    let Signature = value?.FacturaElectronica["ds:Signature"];
    factura.DocumentoFirmado = Signature;
    factura.CondicionVenta = value?.FacturaElectronica?.CondicionVenta?._text;
    return factura;
  };

  const valorVacio = (value) => {
    return IsNotNullOrEmptyOrUndefined(value) ? value : null;
  };

  const onclickAgregar = () => {
    let documents = [];
    closeMessages();
    setElementos([]);
    setDocumentos([]);
    archivos.forEach(item => {
      let estado = '';
      if (!item?.FacturaElectronica && item?.TiqueteElectronico) {
        setMessage('El archivo no corresponde a una factura electrónica.');
       return;
      }
      else if (!item?.FacturaElectronica && item?.NotaCreditoElectronica) {
        item = {
          ...item,
          FacturaElectronica: { ...item?.NotaCreditoElectronica }
        }
      }else if (!item?.FacturaElectronica && !item?.NotaDebitoElectronica) {
        setMessage('El archivo no corresponde a una factura electrónica.');
        return;
      }

      if (!IsNotNullOrEmptyOrUndefined(item?.FacturaElectronica?.Receptor)) {
        estado = estadoConfirmacionEnum.ErrorReceptor;
      } else {
        if (emisor.Identificacion.Numero !== item?.FacturaElectronica?.Receptor?.Identificacion?.Numero?._text) {
          estado = estadoConfirmacionEnum.ErrorCedula;
        }
      }
      if (item?.FacturaElectronica && !IsNotNullOrEmptyOrUndefined(item?.FacturaElectronica["ds:Signature"])) {
        estado = estadoConfirmacionEnum.ErrorFirma;
      }
      item.FacturaElectronica.Estado = estado;
      const newDoc = crearDocumentos(item);
      documents.push(newDoc);
    });
    setDocumentos(documents);
    closeMessages();
  };
  const setArray = (item) => {
    setElementos(item);
  };

  const setDocs = (item) => {
    setDocumentos(item);
  };


  const validarElementos = (array) => {
    let errores = [];
    if (array.length > 0) {
      array.map((dato) => {
        if (!IsNotNullOrEmptyOrUndefined(dato.DetalleMensaje)) {
          if (errores.length === 0) {
            errores.push("Las siguientes facturas (Claves) no poseen razon de rechazo o aceptación parcial: ");
          }
          errores.push(dato.Clave);
        }
      });
    } else {
      errores.push("No existen facturas seleccionadas");
      return errores;
    }
    return errores;
  };

  const closeMessages = () => {
    setMgType('');
    setMessage('');
  };
  const closeError = () => {
    setIsActiveModalError(false);
    closeMessages();
  }

  const onclickConfirmar = () => {
    let errores = validarElementos(elementos);
    if (errores.length === 0) {
      props.postConfirmacionFacturas(token.access_token, elementos);
    } else {
      setMgType(messageTypeEnum.error);
      let texto = '';
      errores.map((item) => {
        texto += item + " ";
      })
      setMessage(texto);
      setIsActiveModalError(true);
    }
  };


  return (
    <>
      <div className="ui Lista-facturas-container">

        <RenderHeader titulo="CONFIRMACIÓN DE FACTURAS" />

        <div className="ui segment stackable row grid">
          <div className="row">
            <div className="column file">
              <span> <label htmlFor="#elegir">Seleccione las facturas a confirmar: </label></span>
            </div>
          </div>

          <div className="row mb-1">
            <div className="eight wide column center-text">
              <input className="blue inline button custom-file-input" id="elegir" name="uploadedfile" accept=".xml" multiple type="file" onChange={(e) => subirArchivos(e)} />
            </div>
            <div className="eight wide column center-text">
              {(archivos?.length > 0) && (<input type="submit" className="but2 ui blue inline button" onClick={() => onclickAgregar()} value={`Subir ${archivos?.length > 0 ? archivos?.length : ''} archivos`} />)}
            </div>
          </div>
        </div>
        <BasicMessage message={message} type={mgType} onClick={() => closeMessages()} />

        {(documentos.length > 0) && (<ListadoDocumentosConfirmacion documentos={documentos} setDocs={(documentos) => setDocs(documentos)} setArray={(elementos) => setArray(elementos)} />)}
        {(documentos.length > 0) && !props.isLoading && (<div className="ui segment2">
          <div className="ui right aligned grid">
            <div className="column">
              <input type="submit" className=" ui blue inline button " onClick={() => onclickConfirmar()} value="Confirmar" />
            </div>
          </div>
        </div>
        )}
      </div>
      <Modal
        centered={false}
        size="small"
        open={isActiveModalError}
        onClose={() => setIsActiveModalError(false)}
      >
        <Modal.Header>Error</Modal.Header>
        <Modal.Content>
          <BasicMessage message={message} type={mgType} onClick={() => closeMessages()} />
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={() => closeError()}>
            Cerrar
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  )

};

const mapStateToProps = (state) => {
  return {
    loginState: state.loginState,
    confirmacionFacturasState: state.confirmacionFacturasState,
    isLoading: state.isLoadingState,
    emisorState: state.emisorState,
  };
};

export default connect(mapStateToProps, { clearErrors, postConfirmacionFacturas, getConfirmados, clearConfirmados })(ConfirmarFacturas);
